import CustomTextInput from "../atoms/custom-text-input.atom.jsx";
import CustomSelect from "../atoms/custom-select.atom.jsx";
import PropTypes from "prop-types";
import CustomText from "../atoms/custom-text.atom.jsx";
import { FaCheckCircle } from 'react-icons/fa';

const GeneralInformationTemplate = ({
    isLoading,
    loanUsageOptions,
    onLoanUsageSelection,
    userOccupationOptions,
    onUserOccupationSelection,
    referralCode,
    onReferralCodeInput,
    referralCodeValidated,
    handleReferralCodeValidation
}) => {

    return (
        <div style={styles.container}>
            <CustomSelect
                label={'¿Cuál es tu ocupación actual?'}
                placeholder={'¿Cuál es tu ocupación actual?'}
                options={userOccupationOptions}
                onChange={onUserOccupationSelection}
                disabled={userOccupationOptions?.length === 0 || isLoading}
            />
            <CustomSelect
                label={'¿Para qué usarás este préstamo?'}
                placeholder={'¿Para qué usarás este préstamo?'}
                options={loanUsageOptions}
                onChange={onLoanUsageSelection}
                disabled={loanUsageOptions?.length === 0 || isLoading}
            />
            {
                referralCodeValidated ?
                    <ReferralCodeValid /> :
                    <CustomTextInput
                        onBlur={handleReferralCodeValidation}
                        disabled={isLoading}
                        maxLength={10}
                        label={'Código de referido'}
                        placeholder={'Código de referido'}
                        value={referralCode}
                        right={() => referralCodeValidated ? <FaCheckCircle color='#009900' /> : null}
                        helper={'Opcional'}
                        onChange={onReferralCodeInput}
                        error={(referralCode?.length === 10 && !referralCodeValidated) ? 'Codigo de referido invalido' : null}
                    />
            }

        </div>

    );
};


GeneralInformationTemplate.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    loanUsageOptions: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.any.isRequired,
        label: PropTypes.string.isRequired
    })).isRequired,
    onLoanUsageSelection: PropTypes.func.isRequired,
    userOccupationOptions: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.any.isRequired,
        label: PropTypes.string.isRequired
    })).isRequired,
    onUserOccupationSelection: PropTypes.func.isRequired,
    referralCode: PropTypes.string,
    onReferralCodeInput: PropTypes.func,
    referralCodeValidated: PropTypes.bool.isRequired
};

const ReferralCodeValid = () => {
    return (
        <div style={{ ...styles.container, flexDirection: 'row', marginTop: '16px' }}>
            <FaCheckCircle color='#009900' />
            <CustomText>Código de referido aplicado</CustomText>
        </div>
    )
}

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        width: '100%'
    }
};

export default GeneralInformationTemplate;